import axios from "axios";

import { getApiBase } from "../../helpers/apiBase";

const BaseURL = getApiBase();
const postData = async (url, body) => {
  const jwsToken = localStorage.getItem("jws_token");
  const response = await fetch(`${BaseURL}/${url}`, {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: jwsToken,
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json",
    },
    //  'content-type': 'multipart/form-data'},
    body: JSON.stringify(body),
  });

  if (response.status === 401) {
    localStorage.clear();
  }

  const result1 = await response.json();
  return result1;
};

const getData = async (url) => {
  const jwsToken = localStorage.getItem("jws_token");

  const response = await fetch(`${BaseURL}/${url}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Authorization: jwsToken,
      "Content-Type": "application/json; charset=utf-8",
    },
  });

  if (response.status === 401) {
    localStorage.clear();
    window.location.reload(false);
  }

  const result2 = await response.json();
  return result2;
};

const axiosPostData = async (url, formData, options = {}) => {
  const { preserveSessionOn401 = false } = options;

  return axios
    .post(`${BaseURL}/${url}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        // Authorization: localStorage.getItem("jws_token"),
      },
    })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      // Check if response exists before accessing status (handles network errors)
      if (err.response && err.response.status === 401 && !preserveSessionOn401) {
        localStorage.clear();
        window.location.reload(false);
      }
      // Throw error so it gets caught by the caller's try-catch
      throw err;
    });
};
export { postData, getData, axiosPostData };
